import { createStore, applyMiddleware, compose } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import Raven from 'raven-js';
import createSagaMiddleware from 'redux-saga';
import createRavenMiddleware from 'raven-for-redux';
import { routerMiddleware } from 'connected-react-router';
import root from './rootSaga';
import rootReducer from './reducers/rootReducer';
import history from './containers/Utils/history';
import socketMiddleware from './containers/socket/socketMiddleWare';

const sagaMiddleware = createSagaMiddleware();
const middleware = [thunk, socketMiddleware, createRavenMiddleware(Raven, {}), sagaMiddleware, routerMiddleware(history)];

const store = configureStore({
  reducer: rootReducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
});

sagaMiddleware.run(root);

export default store;
